export default function Notifications() {
  return (
    <section className="sales-layout__page">
      <h1>Benachrichtigungen</h1>
      <p>Die Benachrichtigungen sind in Vorbereitung.</p>
    </section>
  );
}
